import { config, RoundingTotal, withRoundingTotal } from '../dependencies';

import { decimalDifferenceSelector } from '../services/selectors';

export default withRoundingTotal({
    formId: config.forms.updateExpense,
    decimalDifferenceSelector,
})(RoundingTotal);
